/**
 * Copyright © 2025-2026 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import zampTheme from "./theme";
import { brandCdn, faviconUrl } from './brandAssets';

const fontFallbacks = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
document.documentElement.style.setProperty("--zamp-font-body", `"Season Sans", ${fontFallbacks}`);
document.documentElement.style.setProperty("--zamp-font-headline", '"Season Mix", Georgia, "Times New Roman", serif');

const fontStyle = document.createElement("style");
fontStyle.textContent = `
@font-face {
  font-family: "Season Sans";
  src: url("${brandCdn}/fonts/Season%20Sans/SeasonSans-Regular.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Season Sans";
  src: url("${brandCdn}/fonts/Season%20Sans/SeasonSans-Medium.woff2") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Season Sans";
  src: url("${brandCdn}/fonts/Season%20Sans/SeasonSans-Bold.woff2") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Season Mix";
  src: url("${brandCdn}/fonts/Season%20Mix/SeasonMix-Regular.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Season Mix";
  src: url("${brandCdn}/fonts/Season%20Mix/SeasonMix-Medium.woff2") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Season Mix";
  src: url("${brandCdn}/fonts/Season%20Mix/SeasonMix-Bold.woff2") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
`;
document.head.appendChild(fontStyle);

const setFavicon = (href) => {
  document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']").forEach((el) => el.remove());
  const link = document.createElement("link");
  link.rel = "icon";
  link.type = "image/jpeg";
  link.href = href;
  document.head.appendChild(link);
};
setFavicon(faviconUrl);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <BrowserRouter>
        <ThemeProvider theme={zampTheme}>
            <CssBaseline />
            <App />
        </ThemeProvider>
    </BrowserRouter>
);

reportWebVitals();
